import { clampMediaTime } from "./timeline";

const ACK_TOLERANCE_SECONDS = 3;
export const SEEK_RETRY_INTERVAL_MS = 1400;
const MAX_ATTEMPTS = 4;
export const SEEK_TIMEOUT_MS = 12_000;

export type SeekTransaction = {
  targetSeconds: number;
  requestedAt: number;
  lastCommandAt: number;
  attempts: number;
  notifyOnTimeout: boolean;
};

export type SeekProgressDecision =
  | { kind: "accept"; positionSeconds: number }
  | { kind: "hold" }
  | { kind: "retry"; transaction: SeekTransaction }
  | { kind: "timeout"; positionSeconds: number };

export function beginSeekTransaction(
  requestedSeconds: number,
  durationSeconds: number,
  now = Date.now(),
  notifyOnTimeout = true,
): SeekTransaction | null {
  const targetSeconds = clampMediaTime(requestedSeconds, durationSeconds);
  if (targetSeconds === null) return null;
  return { targetSeconds, requestedAt: now, lastCommandAt: now, attempts: 1, notifyOnTimeout };
}

export function evaluateSeekProgress(
  transaction: SeekTransaction,
  reportedSeconds: number,
  durationSeconds: number,
  now = Date.now(),
): SeekProgressDecision {
  const positionSeconds = clampMediaTime(reportedSeconds, durationSeconds);
  if (positionSeconds === null) return { kind: "hold" };
  if (Math.abs(positionSeconds - transaction.targetSeconds) <= ACK_TOLERANCE_SECONDS) {
    return { kind: "accept", positionSeconds };
  }
  if (now - transaction.requestedAt >= SEEK_TIMEOUT_MS) {
    return { kind: "timeout", positionSeconds };
  }
  if (
    transaction.attempts < MAX_ATTEMPTS &&
    now - transaction.lastCommandAt >= SEEK_RETRY_INTERVAL_MS
  ) {
    return {
      kind: "retry",
      transaction: {
        ...transaction,
        lastCommandAt: now,
        attempts: transaction.attempts + 1,
      },
    };
  }
  return { kind: "hold" };
}
